import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBezierCurves: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bezier-curves, animation, motion, spring"><path d="M16.25 7.75H16.1969C12.0476 7.75101 11.9524 16.25 7.80312 16.25H7.75M3.75 3.75H20.25V20.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBezierCurves;
